import React, { createContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleLoginTokenListeners, nativeEnvironment, nativePostMessage } from "app/views/track_car/common/components/NativeInterface";
import moment from "moment";
import { sessionActions } from "app/redux/reducers/session";
import { useNavigate } from "react-router-dom";
import useAuth from "app/hooks/useAuth";
import { useCatch } from "app/views/track_car/reactHelper";
import { devicesActions } from "app/redux/reducers/devices";

const TracCarContext = createContext({
    // ...initialState,
    handlePasswordLogin: () => { },
});


export const TracCarProvider = () => {
    const { user } = useAuth() // get logged in user details

    const generateLoginToken = async () => { // generate login token after successfully session created
        let token = '';
        try {
            const expiration = moment().add(6, 'months').toISOString();
            const response = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/session/token`, {
                method: 'POST',
                credentials: 'include',
                body: new URLSearchParams(`expiration=${expiration}`),
            });
            if (response.ok) {
                token = await response.text();
                const res = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/devices`, {
                    credentials: 'include',
                  });
                  if (res.ok) {
                    dispatch(devicesActions.refresh(await res.json()));
                  } else {
                    throw Error(await res.text());
                  }
                  const positionsResponse = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/positions`, {
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                  });
                  if (positionsResponse.ok) {
                    dispatch(sessionActions.updatePositions(await positionsResponse.json()));
                  }
          
            }
        } catch (error) {
            token = '';
        }
        nativePostMessage(`login|${token}`);
    };

    const handlePasswordLogin = async () => { // create session for traccar
        if (user && user.resource_access['react-app'].roles[0] != 'student') {
            var email = user.preferred_username
            var password = 'vts@123'
            if (email == 'mis' || email == 'state' || email == 'admin') {
                email = 'admin'
                password = '99Inchrod'
            }
            try {
                const response = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/session`, {
                    method: 'POST',
                    credentials: 'include',
                    body: new URLSearchParams(`email=${email}&password=${password}`),
                });
                if (response.ok) {
                    const user = await response.json();
                    generateLoginToken();
                    dispatch(sessionActions.updateUser(user));
                } else {
                    throw Error(await response.text());
                }
            } catch (error) {
                console.log(error)
            }
        }
    };

    const handleTokenLogin = useCatch(async (token) => { // handle token login 
        const response = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/session?token=${encodeURIComponent(token)}`, {
            credentials: 'include',
        });
        if (response.ok) {
          const user = await response.json();
          dispatch(sessionActions.updateUser(user));
        } else {
          throw Error(await response.text());
        }
    });

    const dispatch = useDispatch()// hooks define

    useEffect(() => {// Create session of traccar on every reload of page
        handlePasswordLogin()
    }, [])

    useEffect(() => {
        const listener = (token) => handleTokenLogin(token);
        handleLoginTokenListeners.add(listener);
        return () => handleLoginTokenListeners.delete(listener);
      }, []);

    return (
        <TracCarContext.Provider
            value={{ handlePasswordLogin }}
        ></TracCarContext.Provider>
    );
};

export default TracCarContext;
